import { initializeApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage, ref, uploadBytes } from "firebase/storage";

// Dynamic Firebase configuration based on environment variables
const getFirebaseConfig = () => {
  return {
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  };
};

const createFirebaseApp = () => {
  if (getApps().length <= 0) {
    const config = getFirebaseConfig();
    const app = initializeApp(config);
    // Check that `window` is in scope for the analytics module!
    if (typeof window !== "undefined") {
      // Enable analytics. https://firebase.google.com/docs/analytics/get-started
      if (config.measurementId) {
        getAnalytics();
      }
    }
    return app;
  }
  return getApps()[0];
};

// Create Firebase App
export const app = createFirebaseApp();
// Export Firebase Modules
export const auth = getAuth(app);
export const cloud = getFunctions(app, "europe-west1");
export const db = getFirestore(app);
// Firebase Storage - will use the bucket and location specified in your Firebase project config
export const fileStorage = getStorage(app);
export const storage = {
  ...fileStorage,
  upload: uploadBytes,
  ref: (path: string) => ref(fileStorage, path),
};
